import { Card, CardContent } from '@/components/ui/card';

const SessionStatus = ({ sessionDuration, onEndSession }) => {
  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Card className="glass border-0">
      <CardContent className="p-4">
        <div className="text-center">
          <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full font-semibold text-sm mb-2 text-white" style={{ backgroundColor: '#24B219' }}>
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <span>Session active</span>
          </div>
          <div className="text-2xl font-bold" style={{ color: '#002768' }} data-testid="session-duration">
            {formatDuration(sessionDuration)}
          </div>
          <button
            onClick={onEndSession}
            className="mt-3 px-4 py-2 bg-rose-500 text-white rounded-lg text-sm font-semibold hover:bg-rose-600"
            data-testid="end-session-button"
          >
            Terminer la Session
          </button>
        </div>
      </CardContent>
    </Card>
  );
};

export default SessionStatus;
